const o = 560, i = 0.8, a = 40, s = 80, t = (n) => ({
  hidden: {
    opacity: 0,
    transition: {
      delay: 0,
      duration: (n == null ? void 0 : n.get("tokens.motion.duration.slow.02")) / 1e3,
      ease: "linear",
      when: "afterChildren"
    }
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0,
      duration: (n == null ? void 0 : n.get("tokens.motion.duration.slow.02")) / 1e3,
      ease: "linear",
      when: "beforeChildren"
    }
  }
}), r = (n) => ({
  hidden: {
    opacity: 0,
    transition: {
      delay: 0.16,
      duration: 0.24,
      ease: n == null ? void 0 : n.get("tokens.motion.easing.exit")
    },
    y: -80
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.16,
      duration: 0.4,
      ease: n == null ? void 0 : n.get("tokens.motion.easing.entrance")
    },
    y: 0
  }
}), d = (n) => ({
  hidden: {
    opacity: 0,
    transition: {
      duration: (n == null ? void 0 : n.get("tokens.motion.duration.moderate.02")) / 1e3,
      ease: n == null ? void 0 : n.get("tokens.motion.easing.exit")
    },
    x: 40
  },
  visible: {
    opacity: 1,
    transition: {
      duration: (n == null ? void 0 : n.get("tokens.motion.duration.moderate.01")) / 1e3,
      ease: n == null ? void 0 : n.get("tokens.motion.easing.entrance")
    },
    x: 0
  }
});
export {
  a as DIALOG_OFFSET,
  o as LARGE_DRAWER_WIDTH,
  i as SMALL_DRAWER_HEIGHT_OFFSET,
  s as STANDARD_DIALOG_OFFSET,
  d as drawerDialogAnimations,
  t as overlayAnimations,
  r as standardDialogAnimations
};
